/** Compact relative age for pipeline table cells (e.g. "3d ago"). */
export function formatRelativeAge(iso?: string | null): string {
    if (!iso) {
        return '—'
    }
    const then = new Date(iso).getTime()
    if (Number.isNaN(then)) {
        return '—'
    }
    const diffMs = Date.now() - then
    if (diffMs < 0) {
        return 'just now'
    }
    const seconds = Math.floor(diffMs / 1000)
    if (seconds < 60) {
        return 'just now'
    }
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) {
        return `${minutes}m ago`
    }
    const hours = Math.floor(minutes / 60)
    if (hours < 24) {
        return `${hours}h ago`
    }
    const days = Math.floor(hours / 24)
    if (days < 60) {
        return `${days}d ago`
    }
    try {
        return new Date(iso).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
        })
    } catch {
        return '—'
    }
}

export function maxIsoDate(
    ...candidates: Array<string | null | undefined>
): string | null {
    let best: string | null = null
    let bestMs = -Infinity
    for (const value of candidates) {
        if (!value) {
            continue
        }
        const ms = new Date(value).getTime()
        if (Number.isNaN(ms)) {
            continue
        }
        if (ms > bestMs) {
            bestMs = ms
            best = value
        }
    }
    return best
}
